<div [hidden]="dataLoading" *ngIf="data?.length > 0" class="wrapper-div">
  <app-web-engage-table *ngIf="isTableVisible" [data]="data" [columns]="columns" [notifier]="notifier"
    [gridItem]="gridItem" [isStandAlone]="isStandAlone" [reportCode]="report?.report_Code" [reportInfo]="reportInfo"
    [reportTitle]="report?.shortDescription" [downloadDialogNotifier]="downloadDialogNotifier"></app-web-engage-table>
  <app-web-engage-chart *ngIf="!isTableVisible" [data]="data" [columns]="columns" [notifier]="notifier"
    [reportCode]="report?.report_Code" [reportInfo]="reportInfo" [reportTitle]="report?.shortDescription"
    [gridItem]="gridItem" [isStandAlone]="isStandAlone"
    [downloadDialogNotifier]="downloadDialogNotifier"></app-web-engage-chart>
</div>
<div *ngIf="dataLoading" class="data-loading">
  <i class="fal fa-sync fa-spin --fa-animation-duration:2s;"></i>
  <span>{{ 'dashboard:Loading' | i18next }}...</span>
</div>
<div *ngIf="data?.length==0 " class="restricted-data">
  <div class="no-data-icon"><i class="fal fa-database"></i></div>
  <span class="restricted-title">{{ 'dashboard:No data available' | i18next }}</span>
  <span class="restricted-description">{{ "dashboard:There is no data to show you right now." | i18next }}</span>
</div>